import { ChevronRight } from "lucide-react";
import type React from "react";
import UserProfileWidget from "@/features/notebook/components/UserProfileWidget";
import type { NotebookHeaderProps } from "@/features/notebook/types/notebook";
import knowgemGem from "@/images/knowgem-gem.svg";

const NotebookHeader: React.FC<NotebookHeaderProps> = ({ workspaceName, onBackToGrid }) => {
	return (
		<header className="surface-alt border-b border-strong px-6 py-3 flex items-center justify-between">
			<div className="flex items-center gap-2">
				<button
					type="button"
					onClick={onBackToGrid}
					className="flex-shrink-0 soft-hover rounded p-0.5 transition-colors"
					aria-label="Back to workspaces"
				>
					<img src={knowgemGem} alt="KnowGem Logo" className="h-6 w-6" />
				</button>
				<ChevronRight className="w-3.5 h-3.5 text-subtle flex-shrink-0" />
				<span className="text-base font-semibold text-primary truncate">{workspaceName}</span>
			</div>
			<div className="flex items-center gap-3">
				<UserProfileWidget />
			</div>
		</header>
	);
};

export default NotebookHeader;
